import cn from 'classnames';
import React from 'react';

import Button, { ButtonSize, ButtonType } from '../button/button';
import styles from './toast.module.scss';

export const enum ToastType {
  Regular = 'regular',
  Warning = 'warning',
}

type ToastProps = {
  text: string;
  type: ToastType;
  hasBtn: boolean;
  btnText: string;
  icon: string;
  isHidden: Boolean;
  btnClickHandler: () => void;
};

const Toast = ({ text, type, hasBtn, btnText, icon, isHidden = false, btnClickHandler }: ToastProps) => {
  return (
    <div
      className={cn(styles.container, styles[type], {
        [styles.hasBtn]: hasBtn,
        [styles.hideWithDelay]: isHidden,
      })}
    >
      {icon && icon !== 'alert' && (
        <i className={cn(styles.iconHolder, 'susu-icons')} translate="no">
          {icon}
        </i>
      )}
      {icon === 'alert' && <div className={styles.iconHolder} />}
      <div className={styles.text}>{text}</div>
      {hasBtn && btnClickHandler && (
        <div className={styles.btnHolder}>
          <Button onClick={btnClickHandler} size={ButtonSize.Small} testId="toast-btn" type={ButtonType.Warning}>
            {btnText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Toast;
